export const TRAILERS_PATH = '/trailers'

export function trailerHistoryPath(trailerId: string): string {
  return `${TRAILERS_PATH}/${trailerId}`
}
